import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown, faArrowAltCircleUp } from '@fortawesome/free-solid-svg-icons';

// Percentage change between two periods. The tables used to show a bare up/down
// arrow, which told you the direction but not whether it mattered -- a 0.4% dip
// and a 60% collapse looked identical.
function Delta({ current, previous, className }) {
  const now = Number(current);
  const before = Number(previous);

  if (!Number.isFinite(now) || !Number.isFinite(before) || before === 0) {
    return <span className={`${className || ''} text-muted`}>—</span>;
  }

  const pct = ((now - before) / Math.abs(before)) * 100;
  const up = pct >= 0;

  return (
    <span
      className={`${className || ''} ${up ? 'text-success' : 'text-danger'} inline-flex items-center gap-1 text-xs font-semibold tabular-nums`}
    >
      <FontAwesomeIcon icon={up ? faArrowAltCircleUp : faArrowAltCircleDown} />
      {`${up ? '+' : ''}${pct.toFixed(1)}%`}
    </span>
  );
}

export default Delta;
